export enum Currency {
  HRK = 'HRK',
  EUR = 'EUR',
}
